// extracted by mini-css-extract-plugin
export default {"removeBtn":"HighlightedUserListWorkBox_removeBtn__wHf0-"};